import * as React from 'react'
import ReactSelect from 'react-select'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../../core/i18n'
import { agentService } from '../../../../core/services'
import { BREAKPOINT_TABLET_SMALL } from '../../../../static/constants'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import { InputText, InputTextArea } from '../../../atoms'
import AgentLayoutNew from '../_layouts/new'
import STATE_CODES from 'static/stateCodes'

declare var window: interfaces.IWindow
// URLについては長い可能性があるため、inputではあるが別途記述している
const FIELDS = {
  area: 'area',
  meetup_point: 'meetup_point',
  name_en: 'name_en',
  name_ja: 'name_ja',
  sub_area: 'sub_area',
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('meetup_place', { scope: 'activerecord.models' }),
})

const AgentMeetupPlaceNew: React.FC = () => {
  const [selectedArea, setSelectedArea] = React.useState(null)
  const [meetupPointURL, setMeetupPointURL] = React.useState('')
  const handleSubmit = React.useCallback(
    async (initialValues, values) => {
      const result = { ...values, area: selectedArea, meetup_point_url: meetupPointURL }

      const { flush } = await agentService.createMeetupPlace(result)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/agent/meetup_places'
    },
    [selectedArea, meetupPointURL]
  )
  const handleAreaChange = selectedOption => {
    setSelectedArea(selectedOption ? selectedOption.value : null)
  }

  return (
    <AgentLayoutNew
      model="meetup_places"
      title={title}
      fields={FIELDS}
      indexLink="/agent/meetup_places"
      formItems={
        <>
          <input type="hidden" name="area" value={selectedArea || ''} />
          <S.FormItemWrapper>
            <S.ReactSelectWrapper>
              <p className="ReactSelect_Title">
                {I18n.t('generic.area')}
                <span className="InputText_Required">{I18n.t('generic.required')}</span>
              </p>
              <div className="ReactSelect_Main">
                <ReactSelect
                  placeholder="選択してください"
                  options={STATE_CODES.map(code => ({
                    value: code,
                    label: code,
                  }))}
                  onChange={handleAreaChange}
                  menuPortalTarget={document.querySelector('body')}
                />
              </div>
            </S.ReactSelectWrapper>
          </S.FormItemWrapper>
          <S.FormItemWrapper>
            <InputText
              required={true}
              name="sub_area"
              defaultValue=""
              label="Sub Area"
              placeholder="新宿, 渋谷"
            />
          </S.FormItemWrapper>
          <S.FormItemWrapper>
            <InputText
              required={true}
              name="name_ja"
              defaultValue=""
              label="ホテル名"
              placeholder="リッツカールトン"
            />
          </S.FormItemWrapper>
          <S.FormItemWrapper>
            <InputText
              required={true}
              name="name_en"
              defaultValue=""
              label="ホテル名(英語)"
              placeholder="Ritz Carlton"
            />
          </S.FormItemWrapper>
          <S.FormItemWrapper>
            <InputTextArea
              className="meetup_point"
              required={false}
              name="meetup_point"
              defaultValue=""
              label="集合場所"
              placeholder="The 1st floor concierge desk of Tokyo Station Hotel"
            />
          </S.FormItemWrapper>
          <S.FormItemWrapper>
            <InputText
              required={false}
              name=""
              defaultValue=""
              label="ホテルのURL"
              placeholder="https://testhotel.com/"
              onChangeHandler={e => setMeetupPointURL(e.target.value)}
              onBlurHandler={e => setMeetupPointURL(e.target.value)}
            />
          </S.FormItemWrapper>
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}
const S: { [key: string]: AnyStyledComponent } = {}

S.FormItemWrapper = styled.div`
  margin-top: 24px;
  .note {
    margin-left: 180px;
    font-size: 14px;
    margin-top: 5px;
    @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      margin-left: 0px;
    }
  }
  .meetup_point {
    height: 80px;
  }
`
S.ReactSelectWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }
  .ReactSelect_Title {
    min-width: 180px;
    font-size: 15px;
    font-weight: bold;
    line-height: 1;
    margin-top: 8px;

    .InputText_Required {
      display: inline-block;
      color: ${constants.COLORS.cautionText};
      vertical-align: middle;
      font-size: 10px;
      font-weight: 700;
      margin-left: 8px;
    }

    @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      width: 100%;
      margin-bottom: 12px;
    }
  }
  .ReactSelect_Main {
    flex: 1;
    font-size: 15px;
  }
`

export default AgentMeetupPlaceNew
